module.exports = __webpack_public_path__ + "img/star.0437643e.svg";